import axios from "axios";
import store from "@/store/index";
import router from "@/router/index";
import { Loading } from "element-ui";

const request = axios.create({
  baseURL: systemConfig.serverUrl, //接口地址
  timeout: 20 * 1000,
});

let loading;

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "加载中...",
    background: "rgba(0, 0, 0, 0.3)",
  });
}

function endLoading() {
  // 延迟500ms，防止网速特快加载中画面一闪而过
  setTimeout(function () {
    if (loading) loading.close();
  }, 500);
}

//请求拦截
request.interceptors.request.use(
  (config) => {
    config.headers.RequestSource = "manage";
    const token = sessionStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // if(config.url != '/zxd-ywgl/data-syn/restore/log' && config.url != '/file-system/data-syn/restore'){
    //   startLoading();
    // }

    return config;
  },
  (error) => {
    // if(config.url != '/zxd-ywgl/data-syn/restore/log' && config.url != '/file-system/data-syn/restore'){
    //   endLoading();
    // }
    return Promise.reject(error);
  },
);

//响应拦截
request.interceptors.response.use(
  (response) => {
    //console.log("响应拦截");
    if (
      response.config.url != "/zxd-ywgl/data-syn/restore/log" &&
      response.config.url != "/file-system/data-syn/restore"
    ) {
      endLoading();
    }
    return response;
  },
  (error) => {
    console.log(error, "---------");
    console.log("响应拦截错误");
    switch (error.response.status) {
      case 401:
        sessionStorage.clear();
        router.push("/login");
        break;
      default:
    }
    // if(response.config.url != '/zxd-ywgl/data-syn/restore/log' && response.config.url != '/file-system/data-syn/restore'){
    //   endLoading();
    // }
    return Promise.reject(error);
  },
);

export default request;
